import { Col } from '../grid';
export default Col;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/col/index.js
// module id = 940
// module chunks = 0